import { render, staticRenderFns } from "./KurccInspectionsPage.vue?vue&type=template&id=1d1c17aa&scoped=true&"
import script from "./KurccInspectionsPage.vue?vue&type=script&lang=js&"
export * from "./KurccInspectionsPage.vue?vue&type=script&lang=js&"
import style0 from "./KurccInspectionsPage.vue?vue&type=style&index=0&id=1d1c17aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1c17aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
